// ── LIVE BRIEF bar (design: 48px, #F5F3FF, stroke #DDD6FE) ───────

.live-brief {
  align-items: center;
  background: var(--rec-color-brand-surface);
  border-bottom: 1px solid var(--rec-color-brand-border);
  display: flex;
  flex-shrink: 0;
  gap: 8px;
  padding: 8px 16px;
}

.live-brief-chip {
  background: var(--rec-color-brand);
  border-radius: var(--rec-radius-sm);
  color: var(--rec-color-brand-fg);
  flex-shrink: 0;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 2px 6px;
}

.live-brief-summary {
  color: var(--rec-color-brand-muted);
  flex: 1;
  font-size: 11px;
  font-weight: 500;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.live-brief-edit {
  background: transparent;
  border: 0;
  color: var(--rec-color-brand);
  cursor: pointer;
  flex-shrink: 0;
  font-family: var(--rec-font);
  font-size: 11px;
  font-weight: 600;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
}

// ── Screen footer (design: 76px, stroke top) ───────────────────────

.footer {
  background: var(--rec-color-background);
  border-top: 1px solid var(--rec-color-header-border);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 6px;
  justify-content: center;
  padding: 10px 14px;
}

.footer-row {
  align-items: center;
  display: flex;
  gap: 8px;
  width: 100%;
}

.footer-spacer {
  flex: 1;
}

.footer-caption {
  color: var(--rec-color-muted);
  font-size: 10px;
  font-weight: 400;
  line-height: 1.3;
  text-align: center;
}

// ── Buttons ─────────────────────────────────────────────────────────

.btn {
  align-items: center;
  border: 0;
  border-radius: var(--rec-radius-md);
  cursor: pointer;
  display: inline-flex;
  flex: 1;
  font-family: var(--rec-font);
  font-size: 12px;
  font-weight: 600;
  gap: 6px;
  height: 36px;
  justify-content: center;
  padding: 0 14px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.btn-primary {
  background: var(--rec-color-primary);
  color: var(--rec-color-primary-fg);

  &:hover:not(:disabled) {
    background: var(--rec-color-primary-hover);
  }
}

.btn-outline {
  background: var(--rec-color-background);
  box-shadow: inset 0 0 0 1px var(--rec-color-border);
  color: var(--rec-color-muted);

  &:hover:not(:disabled) {
    background: var(--rec-color-neutral-bg);
  }
}

.btn-sm {
  font-size: 12px;
  height: 32px;
  padding: 0 12px;
}

.btn-xs {
  font-size: 11px;
  height: 28px;
  padding: 0 10px;
}
